module.exports = __webpack_public_path__ + "img/unilink_U.ac2591d0.svg";